import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import IntlMessages from 'util/IntlMessages';

const options = [
  {
    value: 0,
    disabled: true,
    label: <IntlMessages id="Choose"/>,
  },
  {
    value: 1,
    disabled: false,
    label: <IntlMessages id="New.prospectus"/>,
  },
  {
    value: 2,
    disabled: false,
    label: <IntlMessages id="New.Contract"/>,
  },
  {
    value: 3,
    disabled: false,
    label: <IntlMessages id="Attachto.prospectus.Contract"/>,
  },
];

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(0),
      //   width: '28ch',
    },
  },
}));

export default function InputComponent(props) {
  const classes = useStyles();
  const [Value, setValue] = React.useState(props.Value);

  const handleChange = (event) => {
    setValue(event.target.value);
    props.onchangeHanelEvent("new", event.target.value);
  };

  return (
    <form className={classes.root}>
      <div>
        <TextField
          select
          error={Value === 0}
          label={<IntlMessages id="Want.Create"/>}
          variant="outlined"
          size="small"
          value={Value}
          fullWidth
          onChange={handleChange}
          SelectProps={{
            native: true,
          }}
        >
          {options.map((option) => (
            <option
              key={option.value}
              disabled={option.disabled}
              value={option.value}
            >
              {option.label}
            </option>
          ))}
        </TextField>
      </div>
    </form>
  );
}
